import React, {
    Component,
} from "react";
import {
    connect,
} from "react-redux";
import _ from "lodash";
import { Rect, Group, Shape } from "react-konva";
import { InchUtility } from "../../../lib/pipe-dataset";
import ManifoldLegComponent from "./manifold-tee-leg-component";
import FlowArrowComponent from "./flow-arrow-component";
import { pipeBedSelectElement } from "../../../actions/pipe-bed-actions";
import { renderAccessoryHelper } from "./pipe-accessory-helper";

class ManifoldTeeComponent extends Component{
    get manifoldOffsetX() {
        return ( this.props.rowSpacing.px / 2 ) - ( this.props.pipeOD / 2 );
    }

    get manifoldWidth() {
        return this.props.rowSpacing.px * this.props.manifoldType;
    }

    get pipeODOffset() {
        return this.props.pipeOD * 0.1;
    };

    handleOnMouseClick = ( e ) => {
        this.props.pipeBedSelectElement(this.props.id);
    };

    handleOnMouseOver = ( e ) => {
        if (this.isSelected()) return;
        e.target.to({
            opacity: 1,
        });
    };

    handleOnMouseOut = ( e ) => {
        if (this.isSelected()) return;
        e.target.to({
            opacity: 0,
        });
    };

    renderManifoldHorizontalPipe = () => {
        const imgUrl = require("../../../media/pipes/PIPE_PITCH_180x48.png");
        const fragmentImg = new window.Image();
        fragmentImg.src = imgUrl;
        const fillPatternScale = this.props.pipeOD / 180;

        return <Rect
            x={0}
            y={0}
            width={this.manifoldWidth}
            height={this.props.pipeOD}
            fillPatternRotation={270}
            fillPatternImage={fragmentImg}
            fillPatternScaleX={fillPatternScale}
            fillPatternScaleY={fillPatternScale}
        />;
    };

    renderManifoldLegs = () => {
        return [...new Array(this.props.manifoldType)].map(( x, i ) =>
            <ManifoldLegComponent arrowOrientation={this.props.arrowOrientation} key={i}
                                  x={this.manifoldOffsetX + ( i * this.props.rowSpacing.px )} y={0}/>,
        );
    };

    renderDivisions = () => {
        return <Shape
            sceneFunc={( context, shape ) => {
                context.beginPath();
                context.moveTo(0, this.pipeODOffset);
                context.lineTo(0, this.props.pipeOD - this.pipeODOffset);
                context.moveTo(this.props.rowSpacing.px * this.props.manifoldType, this.pipeODOffset);
                context.lineTo(this.props.rowSpacing.px * this.props.manifoldType, this.props.pipeOD - this.pipeODOffset);
                context.fillStrokeShape(shape);
            }}
            stroke="grey"
            strokeWidth={1}
        />;
    };

    isSelected = () => {
        return _.isEqual(this.props.id, this.props.selected);
    };

    renderAccessories = () => {
        return renderAccessoryHelper({
            ...this.props.id,
            width: this.props.rowSpacing.px * this.props.manifoldType,
            height: this.props.manifoldRowHeight,
            offSet: this.props.rowSpacing.px,
        }, this.props.pipeElements.find(( e ) => {
            return _.isEqual(this.props.id, e.id);
        }) || {});
    };

    renderHorizontalManifold = () => {
        let x = 0;
        if (this.props.arrowOrientation.horizontal === "RIGHT") {
            x = this.manifoldWidth - this.props.pipeOD;
        }
        return <FlowArrowComponent x={x} arrowOrientation={this.props.arrowOrientation.horizontal}/>;
    };

    render() {
        return (
            <Group
                x={this.props.x - this.manifoldOffsetX}
                y={this.props.y}
                width={this.manifoldWidth}
                height={this.props.manifoldRowHeight}
                rotation={this.props.rotation | 0}
            >
                {this.renderManifoldHorizontalPipe()}
                {this.renderManifoldLegs()}
                {this.renderDivisions()}

                {/*manifold frame useful for debugging*/}
                {/*<Rect*/}
                {/*x={0}*/}
                {/*y={0}*/}
                {/*width={this.props.rowSpacing.px * this.props.manifoldType}*/}
                {/*height={this.props.manifoldRowHeight}*/}
                {/*stroke="red"*/}
                {/*strokeWidth={0.3}*/}
                {/*/>*/}

                {/*manifold selector*/}
                <Rect
                    x={0}
                    y={0}
                    dash={[3, 3]}
                    strokeWidth={.4}
                    stroke={"purple"}
                    width={this.manifoldWidth}
                    onClick={this.handleOnMouseClick}
                    onMouseOut={this.handleOnMouseOut}
                    opacity={this.isSelected() ? 1 : 0}
                    onMouseOver={this.handleOnMouseOver}
                    height={this.props.manifoldRowHeight}
                    fill={this.isSelected() ? "rgba(255, 165,0,0.5)" : "rgba(255,255,255,0.2)"}
                />
                {this.renderAccessories()}
                {this.renderHorizontalManifold()}
            </Group>
        );
    }
}

const mapStateToProps = state => {
    return {
        pipeElements: state.pipeBed.pipeElements,
        numberOfPipeRows: state.pipeBed.numberOfPipeRows,
        bedWidth: state.pipeBed.pipeBedDimensions.width.px,
        rowSpacing: new InchUtility(state.pipeBed.rowSpacing),
        selected: state.pipeGlobals.contextSelectedPipeElement,
        pipeFlowDirection: state.pipeGlobals.pipeFlowDirection,
        pipeOD: state.pipeGlobals.pipeNominalDiameter.pipeOD.px,
        perimeterOffset: new InchUtility(state.pipeGlobals.pipePerimeterOffset),
        manifoldRowHeight: state.pipeGlobals.pipeNominalDiameter.horizontalRowHeight.px,
    };
};

const mapDispatchToProps = {
    pipeBedSelectElement,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ManifoldTeeComponent);



// WEBPACK FOOTER //
// ./src/components/Drawings/Pipes/manifold-tee-component.js